import featureNames from 'constants/feature_names';

angular.module('gym.components').controller('AddEnrolmentLimitSequenceConditionCtrl', ["$scope", "$modalInstance", function($scope, $modalInstance) {
  $scope.featureNames = featureNames;
  $scope.intervalUnits = [['hours', 'hour(s)'], ['days', 'day(s)'], ['weeks', 'week(s)'], ['months', 'month(s)']];
  $scope.params = {
    enable_limit_count: false,
    enable_time_period: false,
    limit_term_unit: 'days'
  };
  $scope.toggleTimePeriod = function(val) {
    $scope.params.enable_time_period = val;
    return $scope.params.limit_to_current_month = false;
  };
  $scope.onLimitToCurrentMonthToggle = function() {
    if ($scope.params.limit_to_current_month) {
      return $scope.params.enable_time_period = false;
    }
  };
  $scope.submit = function() {
    if ($scope.params.enable_limit_count && !($scope.params.limit_count >= 1)) {
      $scope.errors = {
        limit_count: ['Should be greater than or equal to 1']
      };
      return;
    }
    if ($scope.params.enable_time_period && !($scope.params.limit_term_number >= 1)) {
      $scope.errors = {
        limit_term_number: ['Should be greater than or equal to 1']
      };
      return;
    }
    return $modalInstance.close($scope.params);
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
